import axios from 'axios';

import { getToken, getSession } from '@/utils/auth';
// import store from '@/store';
let baseURL;

if (process.env.NODE_ENV === 'development') {
  baseURL = '';
} else if (process.env.NODE_ENV === 'production') {
  baseURL = 'https://api.aifeibaihuo.site/';
}

let service = axios.create({
  baseURL: baseURL,

  // timeout: 10000,
});
// axios请求拦截器
service.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    // store.commit('updatedLoading',true)
    config.headers = {
      ...config.headers,
      'Content-Type': 'application/json',
    };
    if (getToken()) {
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      config.headers['Authorization'] = getToken();
      config.headers['updateSession'] = getSession();
    }
    // 根据环境变量判断当前是打包环境还是生产环境
    if (process.env.NODE_ENV == 'production') {
      // console.log('没有吗？', process.env.NODE_ENV);
      // 在生产环境中执行去除'/api'的操作
      config.url = config.url.replace('/api', '');
    }
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    // return Promise.reject(error);
  },
);
// axios响应拦截器
service.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    // store.commit('updatedLoading', false);
    return response;
  },
  function (error) {
    // 对响应错误做点什么
    console.log('err' + error); // for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000,
    // });
    return Promise.reject(error);
  },
);
export default service;
